export default __webpack_public_path__ + "static/media/NCDenmark.eb6496ba.png";